/**
 * テレメータ
 */
import Repository from "./MapRepository";
import Util from "./../lib/util";

const resource = "";

export default {
  /**
   * 表示範囲の水位GeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getStgObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "stg/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲のダムGeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getDamObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "dam/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲のカメラGeoJson取得
   * @param townCd 市町村コード
   */
  getTmScamGeoJsons(townCd) {
    return Repository.get(`${resource}/scam/` + townCd + `.json`);
  },
  /**
   * 表示範囲の雨量GeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getRnObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "rain/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲の水質GeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getQwtrObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "wtrqual/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲の海岸GeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getCoastObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "coast/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲の積雪GeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getSnwObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "snow/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲の危機管理型水位GeoJson取得
   * @param appTime 対象日時
   * @param cd 都道府県/市町村コード
   */
  getSwstgObsGeoJsons(appTime, cd) {
    let datePath = Util.getDatePath(appTime) + "swstg/";
    return Repository.get(`${resource}/obs/` + datePath + cd + `.json`);
  },
  /**
   * 表示範囲の洪水予報基準観測所GeoJson取得
   * @param baseTime 基準時間
   * @param fldfrCd 洪水予報区間コード
   */
  getFldfrBaseobsGeoJsons(baseTime, fldfrCd) {
    let datePath = Util.getDatePath(baseTime) + "fldfr/";
    return Repository.get(
      `${resource}/baseobs/` + datePath + fldfrCd + `.json`
    );
  },
  /**
   * 表示範囲の水位周知河川情報基準観測所GeoJson取得
   * @param appTime 基準時間
   * @param evstgCd 水位周知河川情報区間コード
   */
  getEvstgBaseobsGeoJsons(baseTime, evstgCd) {
    let datePath = Util.getDatePath(baseTime) + "evstg/";
    return Repository.get(
      `${resource}/baseobs/` + datePath + evstgCd + `.json`
    );
  },
  /**
   * 表示範囲の水防警報基準観測所GeoJson取得
   * @param appTime 基準時間
   * @param fldctlCd 水防警報区間コード
   */
  getFldctlBaseobsGeoJsons(baseTime, fldctlCd) {
    let datePath = Util.getDatePath(baseTime) + "fldctl/";
    return Repository.get(
      `${resource}/baseobs/` + datePath + fldctlCd + `.json`
    );
  },
  /**
   * 表示範囲のダム放流通知基準観測所GeoJson取得
   * @param appTime 基準時間
   * @param damdschCd ダム放流通知区間コード
   */
  getDamdschBaseobsGeoJsons(baseTime, damdschCd) {
    let datePath = Util.getDatePath(baseTime) + "damdsch/";
    return Repository.get(
      `${resource}/baseobs/` + datePath + damdschCd + `.json`
    );
  },

  /**
   * 表示範囲の基準値超過水位GeoJson取得
   * @param appTime 対象日時
   */
  getStgOverGeoJsons(appTime) {
    let datePath = Util.getDatePath(appTime);
    return Repository.get(
      `${resource}/overobs/stg/` + datePath + `over-obs-create.json`
    );
  },
  /**
   * 表示範囲の基準値超過ダムGeoJson取得
   * @param appTime 対象日時
   */
  getDamOverGeoJsons(appTime) {
    let datePath = Util.getDatePath(appTime);
    return Repository.get(
      `${resource}/overobs/dam/` + datePath + `over-obs-create.json`
    );
  },
  /**
   * 表示範囲の基準値超過危機管理型水位GeoJson取得
   * @param appTime 対象日時
   */
  getSwstgOverGeoJsons(appTime) {
    let datePath = Util.getDatePath(appTime);
    return Repository.get(
      `${resource}/overobs/swstg/` + datePath + `over-obs-create.json`
    );
  },
};
